import styled, { css } from 'styled-components';
export const ChartContainer = styled.div `
  position: relative;
  height: 100%;
  width: 100%;
  ${({ resizeable }) => resizeable &&
    css `
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    `}
`;
